import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const paymentModulesRoutes: RouteObject[] = [
  {
    path: ROUTES.PAYMENT_MODULES.LIST,
    element: (
      <PrivateRoute>
        <Pages.PaymentModules />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.PAYMENT_MODULES.CREATE,
    element: (
      <PrivateRoute>
        <Pages.AddPaymentModules />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.PAYMENT_MODULES.EDIT(':id'),
    element: (
      <PrivateRoute>
        <Pages.EditPaymentModules />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.PAYMENT_MODULES.VIEW(':id'),
    element: (
      <PrivateRoute>
        <Pages.ViewPaymentModules />
      </PrivateRoute>
    ),
  },
]

export default paymentModulesRoutes
